<!-- 中奖弹窗 -->
<template>
  <div class="winning-popup">
    <van-overlay :show="show" @click="close" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div v-if="prize.status === 1">
          <p class="text1">恭喜你抽到</p>
          <p class="text2">
            {{ prize.couponAmount }}
            元数币红包
          </p>
          <img
            class="gift"
            :src="
              require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/gift.png`)
            "
            alt=""
          />
          <div class="btn" @click="close">
            <span>开心收下</span>
          </div>
        </div>
        <div v-else class="error-msg">
          优惠券发放异常，<br />请联系<a href="tel:400-662-7299"
            >400-662-7299</a
          >
        </div>
      </div>
      <img
        class="close"
        @click="close"
        :src="
          require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/close.png`)
        "
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { toWeChatClaim } from './community'
export default {
  components: {},
  props: ['prize',],
  data() {
    return {
      show: false
    }
  },
  computed: {

  },
  methods: {
    close() {
      this.setShow(false)
      this.$emit('prizesClose')
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.winning-popup {
  position: relative;
  text-align: center;

  .wrapper {
    margin: 120px 30px 20px 30px;
    background: #3f92e3;
    border-radius: 51px;
    border: 11px solid #fffeff;
    text-align: center;
    .text1 {
      padding: 30px 0 0 0;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      text-shadow: #ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0,
        #ffffff 0 -1px 0;
    }
    .text2 {
      padding: 10px 0 10px 0;
      font-weight: bold;
      font-size: 24px;
      color: #e8433c;
      text-shadow: #ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0,
        #ffffff 0 -1px 0;
    }
    .gift {
      width: 65px;
    }
    .btn {
      border: 3px solid #fff;
      border-radius: 30px;
      margin: 20px auto 30px auto;
      width: 160px;
      span {
        display: block;
        line-height: 2.5;
        border-radius: 30px;
        border: 3px solid #000;
        background: #ffffff;
        font-size: 21px;
        font-weight: 600;
        color: #000000;
      }
    }
    .error-msg {
      font-weight: 600;
      color: #000000;
      padding: 40px 10px 40px 10px;
      font-size: 18px;
      line-height: 1.5;
    }
  }
  .close {
    width: 35px;
  }
}
</style>
